import { useEffect, useState } from "react";
import { getRequest, postRequest } from "../apiRequests/requestApi";
import { useNavigate } from "react-router-dom";
import { AiOutlineArrowLeft } from "react-icons/ai";
import CustomSvg from "../svgs/CustomSvg";

const AllLobbies = () => {
  const [lobbies, setLobbies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [dataLoading, setDataLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    getRequest("/lobbies").then((response) => {
      if (response?.success) {
        setLobbies(response?.data || []);
      } else {
        console.error("Failed to fetch active lobbies:", response?.message);
      }
      setLoading(false);
    });
  }, []);

  const handleJoin = async (lobbyCode, gameName) => {
    setError("");
    setDataLoading(true);
    try {
      const response = await postRequest({
        url: "/join-lobby",
        data: { lobbyCode },
      });
      if (response.success) {
        const { _id: lobbyId, code, gameId } = response.data || {};
        if (lobbyId && code && gameId) {
          navigate(`/games/waiting-room/${lobbyId}/${code}/${gameName}`);
        } else {
          setError("Invalid lobby data received");
        }
      } else {
        setError(response.message || "Failed to join lobby");
      }
    } catch (err) {
      setError(err.message || "Failed to join lobby");
    }
    setDataLoading(false);
  };

  return (
    <div className="p-6 min-h-screen bg-[#130828]">
      <div className="flex items-center gap-4 mb-8">
        <button
          onClick={() => navigate(-1)}
          className="flex items-center gap-2 text-white"
        >
          <CustomSvg name="arrow-left" width={20} height={20} color="#fff" />
          <AiOutlineArrowLeft size={24} />
        </button>
        <h2 className="text-2xl text-white font-semibold">All Lobbies</h2>
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      {loading ? (
        <p className="text-white">Loading...</p>
      ) : lobbies.length === 0 ? (
        <p className="text-white">No active lobbies found.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {lobbies.map((lobby) => (
            <div
              key={lobby?._id}
              className="bg-[#1a0b35] text-white rounded-xl p-4 flex flex-col justify-between shadow-lg"
            >
              <div className="mb-4">
                <div className="flex justify-between items-center mb-3">
                  <h2 className="font-semibold text-lg">Game: {lobby?.gameId?.name}</h2>
                  <span
                    className={`text-xs font-semibold px-2 py-1 rounded-full ${
                      lobby?.active
                        ? "bg-green-700 text-green-100"
                        : "bg-gray-600 text-gray-200"
                    }`}
                  >
                    {lobby?.active ? "Active" : "Inactive"}
                  </span>
                </div>
                <p className="text-sm mb-1">
                  Code: <span className="font-bold">{lobby?.code}</span>
                </p>
                <p className="text-sm mb-1">
                  Wager: <span className="font-bold">{lobby?.wagerAmount}</span>
                </p>
                <p className="text-sm mb-1">
                  Participants:{" "}
                  <span className="font-bold">
                    {lobby?.participants?.length}
                  </span>
                </p>
                <p className="text-sm mb-1">
                  In Game:{" "}
                  <span className="font-bold">
                    {lobby.inGame ? "Yes" : "No"}
                  </span>
                </p>
                <p className="text-sm">
                  Created:{" "}
                  <span className="font-medium">
                    {new Date(lobby.createdAt).toLocaleString()}
                  </span>
                </p>
              </div>
              <button
                onClick={() => handleJoin(lobby.code, lobby.gameId.name)}
                className="mt-auto bg-yellow-500 text-black hover:bg-yellow-600 font-semibold px-4 py-2 rounded-lg transition"
              >
                Go to Match
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllLobbies;
